import Vue from 'vue';
import PWAInstaller,{WebClipDetect} from "../components/pwa-installer.vue";
import {Workbox} from 'workbox-window';
import env from "env";

const SW_SCOPE = window.SW_SCOPE || "/";

const IS_GLORIOUS = global.NAMESPACE == "glorious";

export {WebClipDetect};
export default {
    installServiceWorker() {
        if (env.IS_DEVELOPMENT) {
            /**
             *
             * 开发环境重新注册 sw
             */
            this.uninstallServiceWorker();
        }
        if ('serviceWorker' in navigator) {
            const wb = new Workbox("/service-worker.js", {scope: SW_SCOPE});
            global._wb = wb;
            const eventName = "AppState";
            const container = global;

            wb.addEventListener('message', (event) => {
                // console.log('sw message event', event);
                if (event.data.type === 'PRECACHE_PROGRESS') {
                    const detail = {
                        progress: event.data.payload?.progress || 0,
                    };
                    const windowEvent = new CustomEvent("precache-progress", {
                        detail,
                    })
                    container.dispatchEvent(windowEvent);
                }
            });
            wb.addEventListener('activated', (event) => {
                const windowEvent = new CustomEvent(eventName, {
                    detail: {
                        type: "activated",
                    }
                })
                container.dispatchEvent(windowEvent);
            });
            wb.addEventListener("controlling", (event) => {
                const windowEvent = new CustomEvent(eventName, {
                    detail: {
                        type: "controlling",
                    }
                })
                container.dispatchEvent(windowEvent);
            });
            wb.addEventListener("waiting", (event) => {
                const windowEvent = new CustomEvent(eventName, {
                    detail: {
                        type: "waiting",
                    }
                })
                container.dispatchEvent(windowEvent);
            });
            wb.addEventListener("installed", (event) => {
                const windowEvent = new CustomEvent(eventName, {
                    detail: {
                        type: "installed",
                    }
                })
                container.dispatchEvent(windowEvent);
            });

            const windowEvent = new CustomEvent(eventName, {
                detail: {
                    type: "waiting",
                }
            })
            container.dispatchEvent(windowEvent);
            wb.register();
            wb.active.then((sw) => {
                // this.handlePushPreCache(sw);

                const windowEvent = new CustomEvent(eventName, {
                    detail: {
                        type: "activated",
                    }
                })

                container.dispatchEvent(windowEvent);
            })
        }
    },

    uninstallServiceWorker() {
        if ('serviceWorker' in navigator) {
            navigator.serviceWorker.getRegistration().then((registration) => {
                registration && registration.unregister();
            })
        }
    },

    getCurrentWorkBox() {
        return global._wb;
    },

    addPWAInstaller() {
        const WRAPPER_ID = "pwa_installer_wrapper";

        let exist = document.querySelector(`#${WRAPPER_ID}`);
        if (exist) {
            exist.remove();
        }
        const wrapper = document.createElement("div");
        wrapper.id = WRAPPER_ID;
        document.body.appendChild(wrapper);

        const vm = new Vue({
            render: function (callback) {
                return callback(PWAInstaller, {
                    props: {
                        logo: IS_GLORIOUS ? require("../../public/images/glorious-logo.png") :require('../../public/images/icon.png'),
                        appName: IS_GLORIOUS ? "Glorious Whatsapp PWA" : "Driver Whatsapp PWA",
                    }
                })
            }
        }).$mount(`#${WRAPPER_ID}`)
    },

    detectOnline() {
        window.online = navigator.onLine;
        const handler = () => {
            window.removeEventListener("offline", handler);
            window.removeEventListener("online", handler);

            window.online = navigator.onLine;
        };
        if (window.online) {
            window.addEventListener("offline", handler);
        } else {
            window.addEventListener("online", handler);
        }
        return window.online;
    },

    handlePushPreCache(sw) {
        const _cq = window._cq || [];
        console.log(`handlePushPreCache`, _cq);
        const pushCache = (data) => {
            sw.postMessage({
                type: "PUSH_PRECACHE",
                payload: {
                    entries: data,
                }
            })
        }
        const matchPushFunc = ([func, args]) => {
            console.log(`matchPushFunc`, [func, args]);
            switch (func) {
                case 'setPreCache':
                    pushCache(args);
                    return;
            }
        }
        if (_cq.length > 0) {
            Array.from(_cq).forEach(matchPushFunc);
        }
        window._cq = {
            push: matchPushFunc
        }
    }
}
